<template>
  <a-card :bordered="false">
    <!-- 顶部查询：两个 tab 共用同一查询日期 -->
    <div class="table-page-search-wrapper">
      <div style="display:flex; align-items:center; gap:8px; flex-wrap:wrap;">
        <span>查询日期</span>
        <a-date-picker
          v-model="queryDate"
          :allowClear="false"
          style="width:160px"
          placeholder="选择日期"
        />
        <a-button type="primary" icon="search" @click="query" :loading="loading || yoyLoading">查询</a-button>
      </div>
    </div>

    <!-- animated=false：关掉 tab 切换动画，避免 antd 把所有分页排成带 will-change 的合成轨道(宽表常驻大图层致滚动卡顿)，未激活页改为 display:none 不参与绘制 -->
    <!-- destroyInactiveTabPane：进一步只保留当前 tab 的 DOM；数据仍在内存，切回瞬间重建、不重新查库 -->
    <a-tabs v-model="activeTab" @change="onTabChange" :animated="false" :destroyInactiveTabPane="true" style="margin-top:8px;">
      <a-tab-pane v-if="hasPerm(tabPerms['1'])" tab="各巴每日数据核对" key="1">
        <div style="display:flex; align-items:center; gap:8px; flex-wrap:wrap; margin-bottom:8px;">
          <a-button type="primary" icon="bell" @click="sendDingTalk" :loading="sending">发送到钉钉业务数据群</a-button>
        </div>

    <div style="margin-top:8px; overflow-x:auto;">
      <a-spin :spinning="loading">
        <table class="report-table">
          <colgroup>
            <!-- 主表：项目大类 + 4列数值 -->
            <col style="width:130px">
            <col style="width:100px">
            <col style="width:100px">
            <col style="width:100px">
            <col style="width:140px">
            <!-- 间隔 -->
            <col style="width:28px">
            <!-- 分年度：3列 -->
            <col style="width:76px">
            <col style="width:76px">
            <col style="width:76px">
            <!-- 间隔 -->
            <col style="width:28px">
            <!-- 标准收入折算 -->
            <col style="width:100px">
          </colgroup>
          <thead>
            <!-- 标题行 -->
            <tr>
              <th colspan="5" class="group-title">各项目数据（{{ reportDate }}）</th>
              <td class="spacer"></td>
              <th colspan="3" class="group-title">分年度未到账（万元）</th>
              <td class="spacer"></td>
              <th colspan="1" class="group-title">标准收入折算（万元）</th>
            </tr>
            <!-- 列头行 -->
            <tr>
              <th class="col-main-label">项目大类</th>
              <th class="col-main-num">签单去税<br>保费（万）</th>
              <th class="col-main-num">签单去税<br>佣金（万）</th>
              <th class="col-main-num">到账去税<br>佣金（万）</th>
              <th class="col-main-num">未到账去税佣金<br>（含22-26年）（万）</th>
              <td class="spacer"></td>
              <th class="col-num">24年</th>
              <th class="col-num">23年</th>
              <th class="col-num">22年</th>
              <td class="spacer"></td>
              <th class="col-num">标准收入折算</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(row, index) in rows"
              :key="index"
              :class="{ 'subtotal-row': row.subtotal }"
            >
              <td class="col-main-label">{{ row.label }}</td>
              <td class="col-main-num">{{ fmt(row.cleanPremium) }}</td>
              <td class="col-main-num">{{ fmt(row.cleanBrokerage) }}</td>
              <td class="col-main-num">{{ fmt(row.receivedBrokerage) }}</td>
              <td class="col-main-num">{{ fmt(row.unreceivedBrokerage) }}</td>
              <td class="spacer"></td>
              <td class="col-num">{{ fmtYear(row.label, '2024') }}</td>
              <td class="col-num">{{ fmtYear(row.label, '2023') }}</td>
              <td class="col-num">{{ fmtYear(row.label, '2022') }}</td>
              <td class="spacer"></td>
              <td class="col-num">{{ fmt(row.standardIncome) }}</td>
            </tr>
          </tbody>
        </table>
      </a-spin>
      <div v-if="yoyRateText" class="report-remark">
        备注：签单佣金同比 <strong>{{ yoyRateText }}</strong>
      </div>
    </div>
      </a-tab-pane>

      <a-tab-pane v-if="hasPerm(tabPerms['2'])" tab="同比" key="2">
        <div style="margin-top:8px;">
          <a-spin :spinning="yoyLoading">
            <table class="report-table">
              <colgroup>
                <col style="width:110px">
                <col style="width:130px">
                <col style="width:130px">
                <col style="width:130px">
                <col style="width:90px">
              </colgroup>
              <thead>
                <tr>
                  <th colspan="5" class="group-title">签单佣金同比（{{ reportDate }}）</th>
                </tr>
                <tr>
                  <th class="col-main-label">部门</th>
                  <th class="col-main-label">项目</th>
                  <th class="col-main-num">去年同期去税<br>佣金（万）</th>
                  <th class="col-main-num">今年去税<br>佣金（万）</th>
                  <th class="col-main-num">佣金同比</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(r, i) in yoyDisplayRows"
                  :key="'yoy-' + i"
                  :class="{ 'subtotal-row': r.subtotal }"
                >
                  <td class="col-main-label">{{ r.dept }}</td>
                  <td class="col-main-label">{{ r.project }}</td>
                  <td class="col-main-num">{{ fmt(r.lastYear) }}</td>
                  <td class="col-main-num">{{ fmt(r.thisYear) }}</td>
                  <td class="col-main-num">{{ r.ratio }}</td>
                </tr>
              </tbody>
            </table>
          </a-spin>
        </div>
      </a-tab-pane>

      <a-tab-pane v-if="hasPerm(tabPerms['3'])" tab="年月日表" key="3">
        <div style="margin-top:8px;">
          <div style="margin-bottom:8px;">
            <a-button type="primary" icon="bell" @click="sendLedgerGroup" :loading="sendingLedgerGroup">发送到日月年数据报送群</a-button>
          </div>
          <a-spin :spinning="ledgerLoading">
            <div ref="ledgerExport">
            <div v-for="(t, ti) in ledgerTables" :key="'lg' + ti" style="margin-bottom:18px;">
              <table class="report-table ledger-table">
                <thead>
                  <tr>
                    <th :colspan="t.showReceived ? 16 : 11" class="group-title">
                      {{ t.title }}（{{ reportDate }}，单位：万元）
                    </th>
                  </tr>
                  <tr>
                    <th rowspan="2" class="col-main-label">部门</th>
                    <th v-for="g in btGroups" :key="g.key" :colspan="t.showReceived ? 3 : 2">{{ g.name }}</th>
                  </tr>
                  <tr>
                    <template v-for="g in btGroups">
                      <th :key="g.key + 'p'" class="col-num">签单去税<br>保费</th>
                      <th :key="g.key + 'b'" class="col-num">签单去税<br>佣金</th>
                      <th v-if="t.showReceived" :key="g.key + 'r'" class="col-num">去税到账<br>佣金</th>
                    </template>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(row, ri) in t.rows" :key="ri" :class="{ 'subtotal-row': row.subtotal }">
                    <td class="col-main-label">{{ row.label }}</td>
                    <template v-for="g in btGroups">
                      <td :key="g.key + 'p'" class="col-num">{{ fmt(cell(row, g.key).premium) }}</td>
                      <td :key="g.key + 'b'" class="col-num">{{ fmt(cell(row, g.key).brokerage) }}</td>
                      <td v-if="t.showReceived" :key="g.key + 'r'" class="col-num">{{ fmt(cell(row, g.key).received) }}</td>
                    </template>
                  </tr>
                </tbody>
              </table>
            </div>
            </div>
          </a-spin>
        </div>
      </a-tab-pane>

      <a-tab-pane v-if="hasPerm(tabPerms['4'])" tab="晨会业绩表" key="4">
        <div style="margin-top:8px;">
          <a-spin :spinning="ledgerLoading">
            <table class="report-table morning-table">
              <colgroup>
                <col style="width:130px">
                <col style="width:100px">
                <col style="width:100px">
              </colgroup>
              <thead>
                <tr>
                  <th colspan="3" class="group-title">晨会业绩表（{{ reportDate }}，单位：万元）</th>
                </tr>
                <tr>
                  <th class="col-main-label">部门</th>
                  <th class="col-main-num">当日业绩</th>
                  <th class="col-main-num">本月累计</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(r, i) in morningRows"
                  :key="'mm-' + i"
                  :class="{ 'subtotal-row': r.subtotal }"
                >
                  <td class="col-main-label">{{ r.dept }}</td>
                  <td class="col-main-num">{{ fmt(r.today) }}</td>
                  <td class="col-main-num">{{ fmt(r.month) }}</td>
                </tr>
              </tbody>
            </table>
          </a-spin>
        </div>
      </a-tab-pane>
    </a-tabs>

    <!-- 仅用于钉钉发送的导出表格：只含主表5列、颜色加深，离屏渲染不影响页面显示 -->
    <div ref="exportTable" class="export-wrap">
      <table class="report-table export-table">
        <colgroup>
          <col style="width:220px">
          <col style="width:150px">
          <col style="width:150px">
          <col style="width:150px">
          <col style="width:205px">
        </colgroup>
        <thead>
          <tr>
            <th colspan="5" class="group-title">各项目数据（{{ reportDate }}）</th>
          </tr>
          <tr>
            <th class="col-main-label">项目大类</th>
            <th class="col-main-num">签单去税<br>保费（万）</th>
            <th class="col-main-num">签单去税<br>佣金（万）</th>
            <th class="col-main-num">到账去税<br>佣金（万）</th>
            <th class="col-main-num">未到账去税佣金<br>（含22-26年）（万）</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(row, index) in rows"
            :key="'exp-' + index"
            :class="{ 'subtotal-row': row.subtotal }"
          >
            <td class="col-main-label">{{ row.label }}</td>
            <td class="col-main-num">{{ fmt(row.cleanPremium) }}</td>
            <td class="col-main-num">{{ fmt(row.cleanBrokerage) }}</td>
            <td class="col-main-num">{{ fmt(row.receivedBrokerage) }}</td>
            <td class="col-main-num">{{ fmt(row.unreceivedBrokerage) }}</td>
          </tr>
        </tbody>
      </table>
      <div v-if="yoyRateText" class="report-remark">
        备注：签单佣金同比 <strong>{{ yoyRateText }}</strong>
      </div>
    </div>
  </a-card>
</template>

<script>
import { getAction, postAction } from '@/api/manage'
import moment from 'moment'
import html2canvas from 'html2canvas'
import { USER_AUTH } from '@/store/mutation-types'

// 各 tab 对应的按钮权限码（在"角色管理"里授权，未授权则该 tab 不显示，用法同菜单权限）
const TAB_PERMS = {
  '1': 'operateReport:tab:dailyCheck', // 各巴每日数据核对
  '2': 'operateReport:tab:yoy',        // 同比
  '3': 'operateReport:tab:ledger',     // 年月日表
  '4': 'operateReport:tab:morning'     // 晨会业绩表
}

export default {
  name: 'DailyDataCheck',
  data() {
    return {
      tabPerms: TAB_PERMS,
      queryDate: moment(),
      loading: false,
      sending: false,
      sendingLedgerGroup: false,
      rows: [],
      yearMap: {},
      reportDate: '',
      activeTab: '1',
      yoyRows: [],
      yoyLoading: false,
      ledgerLoading: false,
      ledgerDay: [],
      ledgerMonth: [],
      ledgerYear: [],
      btGroups: [
        { key: 'YW', name: '运维业务' },
        { key: 'ZT', name: '直拓业务' },
        { key: 'HZ', name: '合作业务' },
        { key: 'QT', name: '其他业务' },
        { key: 'ZJ', name: '总计' }
      ]
    }
  },
  computed: {
    // 年月日表三张子表：当日 / 本月累计 / 本年累计（年累计额外展示到账佣金列）
    ledgerTables() {
      return [
        { title: '业绩汇报-日', rows: this.ledgerDay, showReceived: false },
        { title: '业绩汇报-月累计', rows: this.ledgerMonth, showReceived: false },
        { title: '业绩汇报-年累计', rows: this.ledgerYear, showReceived: true }
      ]
    },
    // 晨会业绩表：各部门当日/本月"签单去税佣金总计"，取自年月日表(日表/月表的总计列)，按当日业绩降序排名(本月累计次之)
    morningRows() {
      if (!this.ledgerDay.length) return []
      const monthMap = {}
      this.ledgerMonth.forEach(r => { monthMap[r.label] = r })
      const zjBrok = row => (row && row.cols && row.cols.ZJ ? Number(row.cols.ZJ.brokerage) || 0 : 0)
      const short = { '瑞银巴(筹)': '瑞银巴', '创业赋能与运营管理部': '运管部' }
      const list = []
      let total = null
      this.ledgerDay.forEach(r => {
        if (r.label === '合计') { total = r; return }
        list.push({ dept: short[r.label] || r.label, today: zjBrok(r), month: zjBrok(monthMap[r.label]) })
      })
      list.sort((a, b) => (b.today - a.today) || (b.month - a.month))
      if (total) {
        list.push({ dept: '合计', today: zjBrok(total), month: zjBrok(monthMap['合计']), subtotal: true })
      }
      return list
    },
    // 同比表展示行：逐行 + 每部门小计 + 总计（金额由元转万）
    yoyDisplayRows() {
      const out = []
      let curDept = null
      let dL = 0, dT = 0, tL = 0, tT = 0
      const ratio = (t, l) => (l ? (t / l * 100).toFixed(2) + '%' : '-')
      const pushSub = (dept) => {
        if (dept != null) {
          out.push({ dept: dept + ' 小计', project: '', lastYear: dL / 10000, thisYear: dT / 10000, ratio: ratio(dT, dL), subtotal: true })
        }
      }
      this.yoyRows.forEach(r => {
        const l = Number(r.lastYear) || 0
        const t = Number(r.thisYear) || 0
        if (curDept !== null && r.dept !== curDept) { pushSub(curDept); dL = 0; dT = 0 }
        curDept = r.dept
        dL += l; dT += t; tL += l; tT += t
        out.push({ dept: r.dept, project: r.project, lastYear: l / 10000, thisYear: t / 10000, ratio: ratio(t, l) })
      })
      pushSub(curDept)
      out.push({ dept: '总计', project: '', lastYear: tL / 10000, thisYear: tT / 10000, ratio: ratio(tT, tL), subtotal: true })
      return out
    },
    // tab1 底部"签单佣金同比"备注：直接取同比表(tab2)总计行的比值，保证两处一致、不再各算一份
    yoyRateText() {
      const total = this.yoyDisplayRows.find(r => r.dept === '总计')
      return total && total.ratio !== '-' ? total.ratio : ''
    }
  },
  created() {
    // 默认定位到当前用户有权限的第一个 tab（避免默认 tab 被隐藏后页面空白）
    const first = ['1', '2', '3', '4'].find(k => this.hasPerm(this.tabPerms[k]))
    if (first) this.activeTab = first
    this.query() // 加载当前 tab 数据
    // tab1 底部"签单佣金同比"备注依赖同比数据，tab1 可见时预加载
    if (this.activeTab !== '1' && this.hasPerm(this.tabPerms['1'])) this.loadYoy()
  },
  mounted() {
    // Jeecg 内容区容器(.content-width-Fixed)因 overflow 成了独立纵向滚动容器，某些 tab(如同比)
    // 内容高度会让它多出少量内部滚动，与侧栏(body滚动)不同步→顶部蓝条错开，且滚轮被它 latch 住卡顿。
    // 本页期间给 body 加标记类，用非 scoped 样式把该容器 overflow 放开(整页由 body 统一滚动)；离开还原。
    this.addScrollFix()
  },
  activated() { this.addScrollFix() },      // keep-alive 缓存的页签再次进入
  deactivated() { this.removeScrollFix() }, // keep-alive 离开页签
  beforeDestroy() { this.removeScrollFix() },
  methods: {
    // 放开 Jeecg 内容区/外层容器的 overflow，使整页由 body 统一滚动，消除同比tab的滚轮 latch 卡顿+蓝条错位
    addScrollFix() {
      this._scrollFixEls = []
      document.querySelectorAll('.layout, .content-width-Fixed').forEach(el => {
        this._scrollFixEls.push([el, el.style.overflow])
        el.style.overflow = 'visible'
      })
    },
    removeScrollFix() {
      const els = this._scrollFixEls || []
      els.forEach(pair => { pair[0].style.overflow = pair[1] })
      this._scrollFixEls = []
    },
    // tab 权限判断：读用户已授权的按钮权限码（口径同 v-has 指令），未授权返回 false 则 tab 不显示
    hasPerm(code) {
      try {
        const authList = JSON.parse(sessionStorage.getItem(USER_AUTH) || '[]')
        return authList.filter(a => a.type != '2').some(a => a.action === code)
      } catch (e) {
        return false
      }
    },
    loadReport() {
      if (!this.queryDate) {
        this.$message.warning('请选择查询日期')
        return
      }
      this.loading = true
      const date = this.queryDate.format('YYYY-MM-DD')
      getAction('/biz/dailyCheck/report', { date }).then(res => {
        if (res.success) {
          this.rows = res.result.rows || []
          this.reportDate = res.result.date || date
          this.yearMap = res.result.yearMap || {}
        } else {
          this.$message.error(res.message || '查询失败')
        }
      }).catch(() => {
        this.$message.error('查询失败')
      }).finally(() => {
        this.loading = false
      })
    },
    // 查询按钮：刷新当前 tab 数据
    query() {
      if (this.activeTab === '2') {
        this.loadYoy()
      } else if (this.activeTab === '3' || this.activeTab === '4') {
        // 年月日表与晨会业绩表共用同一份数据（晨会表由年月日表日/月表推导）
        this.loadLedger()
      } else {
        this.loadReport()
        this.loadYoy() // tab1 底部同比备注复用同比表结果，需同步刷新
      }
    },
    // 切 tab：目标 tab 无数据时按当前日期加载
    onTabChange(key) {
      if (key === '2' && this.yoyRows.length === 0) {
        this.loadYoy()
      } else if ((key === '3' || key === '4') && this.ledgerDay.length === 0) {
        this.loadLedger()
      } else if (key === '1' && this.rows.length === 0) {
        this.loadReport()
      }
    },
    loadLedger() {
      if (!this.queryDate) {
        this.$message.warning('请选择查询日期')
        return
      }
      this.ledgerLoading = true
      const date = this.queryDate.format('YYYY-MM-DD')
      getAction('/biz/dailyCheck/ledgerReport', { date }).then(res => {
        if (res.success) {
          this.ledgerDay = res.result.dayTable || []
          this.ledgerMonth = res.result.monthTable || []
          this.ledgerYear = res.result.yearTable || []
          this.reportDate = res.result.date || date
        } else {
          this.$message.error(res.message || '查询失败')
        }
      }).catch(() => {
        this.$message.error('查询失败')
      }).finally(() => {
        this.ledgerLoading = false
      })
    },
    // 取某行某业务类型的单元格（防止空值报错）
    cell(row, key) {
      return (row && row.cols && row.cols[key]) || {}
    },
    loadYoy() {
      if (!this.queryDate) {
        this.$message.warning('请选择查询日期')
        return
      }
      this.yoyLoading = true
      const date = this.queryDate.format('YYYY-MM-DD')
      getAction('/biz/dailyCheck/yoyRows', { date }).then(res => {
        if (res.success) {
          this.yoyRows = res.result || []
          this.reportDate = date
        } else {
          this.$message.error(res.message || '查询失败')
        }
      }).catch(() => {
        this.$message.error('查询失败')
      }).finally(() => {
        this.yoyLoading = false
      })
    },
    sendDingTalk() {
      if (!this.queryDate) {
        this.$message.warning('请选择日期')
        return
      }
      if (!this.rows || this.rows.length === 0) {
        this.$message.warning('暂无报表数据，请先查询')
        return
      }
      this.sending = true
      const date = this.queryDate.format('YYYY-MM-DD')
      // 目标群由后端从字典读取；测试环境自动改发本人、生产发业务群
      // 截取导出表格（仅主表5列、颜色加深）为图片，钉钉两端显示不换行
      html2canvas(this.$refs.exportTable, { backgroundColor: '#ffffff', scale: 2 }).then(canvas => {
        const image = canvas.toDataURL('image/png')
        return postAction('/biz/dailyCheck/sendDingTalk', { date, image })
      }).then(res => {
        if (res.success) {
          this.$message.success('发送成功')
        } else {
          this.$message.error(res.message || '发送失败')
        }
      }).catch(() => {
        this.$message.error('发送失败')
      }).finally(() => {
        this.sending = false
      })
    },
    // 年月日表-发送到日月年数据报送群：截取年月日表图片，后端发钉钉群(非prod自动改发测试群)
    sendLedgerGroup() {
      if (!this.ledgerDay.length) {
        this.$message.warning('暂无数据，请先查询')
        return
      }
      this.sendingLedgerGroup = true
      const date = this.reportDate || (this.queryDate && this.queryDate.format('YYYY-MM-DD'))
      html2canvas(this.$refs.ledgerExport, {
        backgroundColor: '#ffffff',
        scale: 3, // 清晰度倍数，宽表被钉钉预览缩小时字更耐看
        onclone: (doc) => {
          // 仅在截图克隆节点上：字号放大(13→20px)、加粗、纯黑字、深边框；向"各巴发钉钉"那版清晰度看齐，不影响页面显示
          doc.querySelectorAll('.ledger-table').forEach(t => { t.style.fontSize = '20px' })
          doc.querySelectorAll('.ledger-table th, .ledger-table td').forEach(c => {
            c.style.color = '#000'
            c.style.borderColor = '#333'
            c.style.fontWeight = '500'
          })
          // 标题行单独处理：.group-title 自带 font-size:14px 的规则，不会继承上面设在 table 上的 20px，
          // 且会被上一行的 fontWeight:500 冲掉加粗，故这里显式补上——字号与正文一致，靠加粗区分即可
          doc.querySelectorAll('.ledger-table .group-title').forEach(c => {
            c.style.setProperty('font-size', '20px', 'important')
            c.style.setProperty('font-weight', 'bold', 'important')
          })
        }
      }).then(canvas => {
        const image = canvas.toDataURL('image/png')
        return postAction('/biz/dailyCheck/sendLedgerGroup', { date, image })
      }).then(res => {
        if (res.success) {
          this.$message.success('发送成功')
        } else {
          this.$message.error(res.message || '发送失败')
        }
      }).catch(() => {
        this.$message.error('发送失败')
      }).finally(() => {
        this.sendingLedgerGroup = false
      })
    },
    fmt(val) {
      return val != null ? Number(val).toFixed(2) : '0.00'
    },
    fmtYear(label, year) {
      const ydata = this.yearMap[label]
      if (!ydata) return ''
      const val = ydata[year]
      return val != null ? Number(val).toFixed(2) : ''
    }
  }
}
</script>

<style scoped>
.report-remark {
  margin-top: 8px;
  font-size: 13px;
  color: #666;
  padding-left: 2px;
}

.report-table {
  border-collapse: collapse;
  table-layout: fixed;
  width: 954px;
  font-size: 13px;
}

.report-table th,
.report-table td {
  border: 1px solid #d9d9d9;
  padding: 5px 10px;
  overflow: hidden;
}

.report-table thead th {
  background: #fafafa;
  font-weight: 500;
  text-align: center;
  line-height: 1.4;
}

.report-table .group-title {
  font-size: 14px;
  font-weight: bold;
  text-align: center;
  background: #fafafa;
}

/* 间隔列：无边框、白底 */
.report-table .spacer {
  border: none !important;
  background: #fff !important;
  padding: 0 !important;
  width: 28px;
}

.report-table .col-main-label { text-align: left; }
.report-table .col-main-num  { text-align: right; }
.report-table .col-label     { text-align: left; }
.report-table .col-num       { text-align: right; }

/* 小计/合计行 */
.report-table tr.subtotal-row td {
  font-weight: bold;
  background: #f5f5f5;
}

/* 年月日表：列数多，取消固定宽度改自适应，数值列紧凑右对齐 */
.ledger-table {
  width: auto;
  table-layout: auto;
  white-space: nowrap;
}
.ledger-table th,
.ledger-table td {
  padding: 4px 8px;
}
.ledger-table .col-main-label {
  min-width: 150px;
  white-space: nowrap;
}
.ledger-table .col-num {
  min-width: 72px;
}

/* 晨会业绩表：不撑满固定宽度，按 colgroup 列宽显示（列宽减半、更紧凑） */
.morning-table {
  width: auto;
  table-layout: fixed;
}
.morning-table th,
.morning-table td {
  padding: 5px 6px;
}

/* 钉钉发送用的导出表格：离屏渲染 + 颜色加深，避免截图偏淡 */
.export-wrap {
  position: absolute;
  left: -10000px;
  top: 0;
  padding: 16px;
  background: #fff;
}
.export-wrap .report-table {
  width: 875px; /* 5列合计：220+150+150+150+205；末列加宽到205，"未到账...(含22-26年)(万)"控制在两行 */
  color: #000;
  font-size: 22px;         /* 正文 22px 档 */
  line-height: 1.1;
}
.export-wrap .report-table th,
.export-wrap .report-table td {
  border-color: #333;
  color: #000;
  padding: 2px 8px;
  overflow: visible;       /* 覆盖默认 overflow:hidden，避免表头文字被裁剪 */
  white-space: normal;
  word-break: break-word;
}
/* 数据区的金额不换行，保持整齐 */
.export-wrap .report-table tbody .col-main-num {
  white-space: nowrap;
}
/* 行标签(项目大类/各巴小计)强制一行显示，配合首列220px不再换行 */
.export-wrap .report-table .col-main-label {
  white-space: nowrap;
}
.export-wrap .report-table thead th,
.export-wrap .report-table .group-title {
  background: #e6e6e6;
  color: #000;
  font-weight: bold;
  font-size: 22px;
}
.export-wrap .report-table .group-title {
  font-size: 26px;
}
/* 第二行列名表头：靠左对齐 + 字号18px，长表头控制在两行内；数据行不受影响 */
.export-wrap .report-table thead th.col-main-label,
.export-wrap .report-table thead th.col-main-num {
  font-size: 18px;
  text-align: left;
}
.export-wrap .report-table tr.subtotal-row td {
  background: #dcdcdc;
  color: #000;
}
.export-wrap .report-remark {
  margin-top: 8px;
  font-size: 19px;
  color: #000;
}
</style>

